import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addReceipt = ( receipt_date, receipt_amount, applied_amount,customer_id, contract_id,remittance_bank,receipt_method,receipt_reference,status,comments,overide_application,
  attribute) => {
  return axios.post(API + "receipts/create/receipts/", {
    receipt_date,
    receipt_amount,
    applied_amount,
    customer_id,
    contract_id,
    remittance_bank,
    receipt_method,
    receipt_reference,
    status,
    comments,
    overide_application,
    attribute
  },{headers: authHeader(),});
};
const AddReceiptService = {
    addReceipt,
  };
  export default AddReceiptService;